<template>
  <div>
    <dl class="dl-horizontal">
      <dt>{{ $t('campos.titulo') }}</dt>
      <dd>{{ title }}</dd>

      <dt>{{ $t('campos.descripcion') }}</dt>
      <dd><p>{{ description }}</p></dd>

      <dt>{{ $t('campos.fecha_publicacion') }}</dt>
      <dd>{{ creationDate }}</dd>

      <dt>{{ $t('campos.fecha_actualizacion') }}</dt>
      <dd>{{ updateDate }}</dd>
    </dl>
  </div>

</template>

<script>

    import {DateUtils} from "../../../commons/utils/dateUtils";

    export default {
        name: 'InfoTab',
        props: {
            layer: {
                type: Object,
                required: true
            }
        },
        computed: {
            locale() {
                return this.$i18n.locale
            },
            title() {
                return this.layer[`title_${this.locale}`];
            },
            description() {
                return this.layer[`description_${this.locale}`] || '-';
            },
            creationDate() {
                return DateUtils.formatOnlyDate(this.layer['creation_date']);
            },
            updateDate() {
                return DateUtils.formatOnlyDate(this.layer['update_date']);
            },
        },
    }
</script>


<style lang="scss" scoped>
  .dl-horizontal {
    dt {
      text-overflow: clip;
      white-space: normal;
      overflow: hidden;
    }

    @media (min-width: 768px) {
      dt {
        float: left;
        width: 160px;
        clear: left;
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      dd {
        margin-left: 180px;
      }
    }
  }

</style>